import { Provider } from '@angular/core';
import { provideFeatureImportComponents } from 'common-util';
import { NavigationSideMenuImporterComponent } from './auto-load/navigation-side-menu-importer/navigation-side-menu-importer.component';
export function provideNavigationFeature(): Provider {
  return [provideFeatureImportComponents(NavigationSideMenuImporterComponent)];
}
